<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="blendHoneyTypeForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                blendHoneyTypeForm: () => import('../forms/BlendHoneyTypeForm'),
                headers: [
                    { text: 'Blend', value: 'blendId', table: 'blends', form: () => import('../forms/BlendForm') },
                    { text: 'Honey Type', value: 'honeyTypeId', table: 'honeyTypes', form: () => import('../forms/HoneyTypeForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    blends: [],
                    honeyTypes: [],
                    items: []
                },
                sorting: [
                    { column: "blendId", direction: "ascending" },
                    { column: "honeyTypeId", direction: "ascending" },
                ],
                itemsField: 'blendHoneyTypes',
                editPageName: 'blendHoneyType',
                apiMethod: 'BlendHoneyTypes',
                claimName: 'BlendHoneyTypes',
                formTitle: 'Blend Honey Type',
                excelTitle: 'Blend Honey Types',
                hasEditPage: false,
            }
        },
    };
</script>
